import JassEnum from './enum';

/**
 * type fogstate
 */
export default class JassFogState extends JassEnum {}
